import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { JurisdictionData } from '@juvare/platform-app/Integration';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { JurisdictionColumns } from '@juvare/platform-sdk-react/backend/features/default-classifiers/shared';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';

function fetchCountyValues(jurisdictionStorage: StorageClient<JurisdictionData, JurisdictionColumns>, stateCode: string) {
    return jurisdictionStorage.list({
        filter: [
            { column: 'type', op: '=', value: 'county' },
            { column: 'status', op: '=', value: 'active' },
            { column: 'parentPostalCode', op: '=', value: stateCode },
        ],
        orderBy: [{ column: 'name' }],
    });
}

export function useAccountTableDataLists(stateCode?: string) {
    const [stateCounties, setStateCounties] = React.useState<{ value: string; label: string }[]>();
    const jurisdictionStorage = useStorageClient<JurisdictionData, JurisdictionColumns>('jurisdiction');

    React.useEffect(() => {
        if (stateCode) {
            fetchCountyValues(jurisdictionStorage, stateCode)
                .then((result) => {
                    const data = result.rows.map((row) => ({ value: row.columns.name, label: row.columns.name }));
                    setStateCounties(data);
                })
                .catch((e) => {
                    handleErrorSnackbar(e);
                    setStateCounties([]);
                });
        } else {
            setStateCounties([]);
        }
    }, [stateCode, jurisdictionStorage]);

    return { stateCounties };
}
